import { Fragment } from "react";
import { Empty } from "./Empty";
import ColumnActions from "../molecules/ColumnActions";
import { PlusIcon } from "@heroicons/react/20/solid";
import { t } from "i18next";
import ColumnText from "../molecules/ColumnText";

type tagsProps = {
  id: number | string;
  description: string;
  color: string;
  discount: string;
  fee: string;
  fee_course: string;
  name: string;
  fees: any;
  fees_course: any;
};

export type TableListTagsUserProps = {
  tagsUser: tagsProps[];
  OnclickTop: () => void;
};

const TableListTagsUser: React.FC<TableListTagsUserProps> = ({
  tagsUser,
  OnclickTop,
}) => {
  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex w-64"></div>
        <div className="mt-8 sm:ml-auto sm:mt-4 sm:justify-between">
          <button
            onClick={OnclickTop}
            type="button"
            className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
          >
            <PlusIcon aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
      </div>

      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
            {tagsUser.length === 0 ? (
              <div className="mt-2">
                <Empty texto={t("brand.views.no_tags")} />
              </div>
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("brand.views.description")}
                      </th>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("brand.views.discount_percentage")}
                      </th>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-3"
                      >
                        {t("brand.views.fees")}
                      </th>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("brand.views.course_fees")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {tagsUser.map((tagUser) => (
                      <tr key={tagUser.id}>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <span
                            style={{ backgroundColor: tagUser.color }}
                            className="inline-flex items-center rounded-md px-2 py-1 text-sm font-medium text-gray-900"
                          >
                            {tagUser.name}
                          </span>
                        </td>
                        <ColumnText title={tagUser.discount} />

                        {/* fee column */}
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500 max-w-[100px] truncate overflow-hidden text-ellipsis">
                          {tagUser.fees}
                        </td>

                        {/* fee_course column */}
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500 max-w-[100px] truncate overflow-hidden text-ellipsis">
                          {tagUser.fees_course}
                        </td>

                        <ColumnActions name={tagUser.description} />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListTagsUser;
